export const Thunder = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M8.5902 1.49433C8.63209 1.35179 8.71904 1.22666 8.83801 1.13767C8.95699 1.04869 9.10159 1.00065 9.25016 1.00073H14.7498C14.8587 1.00082 14.966 1.02675 15.0629 1.07641C15.1598 1.12607 15.2435 1.19803 15.3071 1.28637C15.3707 1.37471 15.4125 1.4769 15.4289 1.58452C15.4453 1.69215 15.4359 1.80214 15.4015 1.90543L12.9542 9.25024H18.1871C18.3159 9.25015 18.442 9.28621 18.5513 9.35432C18.6605 9.42243 18.7485 9.51984 18.8051 9.63547C18.8617 9.7511 18.8847 9.8803 18.8714 10.0084C18.8582 10.1364 18.8093 10.2582 18.7302 10.3598L9.10579 22.7341C9.0072 22.8614 8.867 22.9502 8.70968 22.9847C8.55235 23.0193 8.38789 22.9975 8.24498 22.9232C8.10207 22.8489 7.9898 22.7267 7.92775 22.5781C7.8657 22.4294 7.85782 22.2637 7.90549 22.1099L10.3817 14.0625H5.81286C5.70598 14.0625 5.60056 14.0377 5.50497 13.9899C5.40938 13.942 5.32625 13.8726 5.26218 13.7871C5.19812 13.7015 5.15489 13.6022 5.13592 13.497C5.11695 13.3918 5.12276 13.2837 5.1529 13.1811L8.5902 1.49433Z"
      fill="#0AAAE6"
    />
  </svg>
);
